export const PLAYBACK_CONTAINER_ID = 'highlights-playback-container';